import React from 'react'
import classnames from 'classnames'

import { Checkbox } from '@fielded/shared-ui'
import { getProgramReadableName } from '@fielded/fs-api/lib/program/tools'
import { SHIPMENT_STATUS } from '@fielded/fs-api/lib/shipment/constants'

import PSMDeliveryCard from '../shared/PSMDeliveryCard/PSMDeliveryCard'

const PSMDriverDeliveryCard = ({
  shipment,
  programs,
  history,
  headerTitle,
  showCompleted,
  isDeliverySelected,
  onToggleCheckbox,
  hideCheckbox,
  isDriver,
  isWarehouseUser,
  canPsmResellerWarehouseUserMoveToPacked
}) => {
  const {
    status,
    snapshotId,
    routeId
  } = shipment
  // Only warehouse users are "warehouse-like" for status checking
  // The canPsmResellerWarehouseUserMoveToPacked flag should not affect drivers
  const isWarehouseLike = isWarehouseUser

  const statusToUse = isWarehouseLike
    ? SHIPMENT_STATUS.NEW
    : SHIPMENT_STATUS.PACKED
  // For drivers (isDriver=true, isWarehouseLike=false), only PACKED shipments are checkable.
  // SENT and ARRIVED shipments will show checkboxes but they will be disabled (status !== PACKED).
  const isCheckboxDisabled = isWarehouseLike
    ? (!routeId || status !== statusToUse)
    : status !== statusToUse

  const programName = getProgramReadableName(shipment.programId, programs)
  const { ARRIVED, RECEIVED } = SHIPMENT_STATUS
  const target = [ARRIVED, RECEIVED].includes(status)
    ? `/shipments/pick-list/${snapshotId}`
    : `/shipments/delivery/${snapshotId}`

  return (
    <PSMDeliveryCard
      headerTitle={headerTitle}
      history={history}
      programName={programName}
      shipment={shipment}
      target={target}
      isDriver={isDriver}
    >
      {!showCompleted && !hideCheckbox && (
        <Checkbox.Stateless
          className={classnames(
            'driver-delivery-card__checkbox',
            {'driver-delivery-card__checkbox--disabled': isCheckboxDisabled}
          )}
          checked={isDeliverySelected}
          disabled={isCheckboxDisabled}
          onChange={onToggleCheckbox}
        />
      )}
    </PSMDeliveryCard>
  )
}

export default PSMDriverDeliveryCard
